module.exports = __webpack_public_path__ + "static/media/logo.9ec1a065.png";